module.exports = __webpack_public_path__ + "img/baska_2.95d341ef.avif";